import React from 'react';
import { withStyles } from '@material-ui/core';

const StatsCards = ({ classes, title, cards, onCardClick }) => {
  const handleCardClick = (index, isDisabled) => {
    if (!isDisabled && onCardClick) {
      onCardClick(index);
    }
  };

  return (
    <div className={classes.container}>
      <h3 className={classes.componentTitle}>{title}</h3>
      <div className={classes.cardsContainer}>
        {cards.map((card, index) => {
          const isDisabled = parseInt(card.quantidade) === 0;
          return (
            <div
              id={`prt-stc-div-crd-${index}`}
              key={index} 
              className={classes.card}
              style={{ borderColor: card.color }}
              onClick={() => handleCardClick(index, isDisabled)}
            >
            <div className={classes.cardIcon} style={{ color: card.color }}>
              {card.icon}
            </div>
            <div 
              className={classes.cardQuantity}
              style={{ color: card.color }}
            >
              {card.quantidade}
            </div>
            <div 
              className={classes.cardTitle}
              style={{ color: card.color }}
            >
              {card.title}
            </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

const styles = {
  container: {
    marginBottom: '20px'
  },
  componentTitle: {
    margin: '0 0 15px 0',
    fontSize: '16px',
    fontWeight: 600,
    color: '#505050'
  },
  cardsContainer: {
    display: 'flex',
    gap: '8px',
    flexWrap: 'wrap'
  },
  card: {
    width: '100px',
    height: '85px',
    border: '1px solid',
    borderRadius: '8px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '3px',
    backgroundColor: 'white',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#f5f5f5'
    }
  },
  cardIcon: {
    fontSize: '1rem',
    marginBottom: '0.25rem'
  },
  cardQuantity: {
    fontSize: '1.25rem',
    fontWeight: 600,
    marginBottom: '0.125rem'
  },
  cardTitle: {
    fontSize: '0.5rem',
    fontWeight: 500,
    textAlign: 'center',
    color: 'black'
  }
};

export default withStyles(styles)(StatsCards);